import { defineFlagKeys } from "@smeetz/utils-feature-flags";

// Bare keys, the "pos" prefix is applied at lookup
// so each resolves to the dashboard flag "pos::<value>"
export const FeatureFlagKeys = defineFlagKeys({
  EndpointsK8sOverride: "endpoints:k8s-override",
  PosSellerPin: "pos-seller-pin",
  PosCheckIn: "pos-check-in",
  WebPosFiscalExemption: "web-pos-fiscal-exemption",
  AustriaCompliancePackage: "austria-compliance-package",
  CashbookV2: "cash-book-v2",
  MultiCurrency: "multi-currency",
  UnifiedReceipt: "unified-receipt",
  Tipping: "tipping",
  ReleaseChannel: "release-channel",
} as const);

export type FeatureFlagKey =
  (typeof FeatureFlagKeys)[keyof typeof FeatureFlagKeys];
